/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-23 15:07:22
 * @LastEditors: K
 * @LastEditTime: 2022-09-09 17:32:35
 */
import React, { ReactElement, useContext, useEffect, useState } from 'react';

import { Button, Form, Input, Row, Space, Cascader as Cascaded, Select, } from 'antd';

import { CaretDownFilled, SearchOutlined } from '@ant-design/icons';
import { stringTrim } from '../../../utils/StringUtils';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { getAllList } from '../../tenant/tenantSlice';
import { ThemeContext } from '../../../theme/ThemeContext';
import { getTeantTypeName, teantTypes } from '../../../models/tenant';
import { DateRangeType, DateSelect } from '../../../compnents/form/DateSelect';

interface useQueryProps {
  submit: (obj: any) => void
  ListExport: () => void
}
export const UseQuery = ({ submit, ListExport }: useQueryProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)


  const [productPriceModalList, setProductPriceModalList] = useState([
    { name: '全部', id: '' },
    { name: '卫生院', id: 2 },
    { name: '药店', id: 1 },
  ])   //产品价格表弹窗数据

  const [allList, setAllList] = useState<any[]>()   //省市数据

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  useEffect(() => {   //获取省市数据
    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setAllList(t)
      })
    form.submit()
  }, [])
  const queryChange = () => {
    const values = form.getFieldsValue()
    submit({
      ...values,
      area: undefined,
      provinceCode: values?.area?.slice(0, 1)[0],
      cityCode: values?.area?.slice(1, 2)[0],
      countyCode: values?.area?.slice(2, 3)[0],
      startTime: values.endTimeHead,
      endTime: values.endTimeTail,
      endTimeHead: undefined,
      endTimeTail: undefined,

    })
  }
  return (
    <div>
      {/* 筛选查询区域 */}
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          console.log(values, '123');
          submit(values)
        }}
      >
        <Row
          justify='space-between'
          align='middle'
          wrap={true}
        // className={styles.queryWrap}
        >
          <Space style={{ marginBottom: 10 }}>
            <Form.Item name='name' noStyle getValueFromEvent={stringTrim}>
              <Input
                allowClear
                placeholder='请输入机构名称'
                prefix={<SearchOutlined />}
                onChange={queryChange}
              />
            </Form.Item>
            <Form.Item name='tenantCategory' noStyle>
              <Select
                placeholder='机构类别-全部'
                onChange={queryChange}
                allowClear
              >
                {productPriceModalList?.map((el: any) => (
                  <Select.Option key={el.id} value={el.id}>
                    机构类别-{el.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name='tenantType' noStyle>
              <Select
                placeholder='机构类型-全部'
                onChange={queryChange}
                allowClear
              >
                {teantTypes.map((el: any) => (
                  <Select.Option key={el} value={el}>
                    机构类型-{getTeantTypeName(el)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name='platformType' noStyle>
              <Select
                placeholder='请选择合作平台'
                onChange={queryChange}
                allowClear
              >
                <Select.Option value={0}>好医点</Select.Option>
                <Select.Option value={1}>聚网</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name='area' noStyle>
              <Cascaded
                loadData={loadData}
                changeOnSelect
                suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                options={allList}
                onChange={queryChange}
                placeholder='请选择省市区'
              />
            </Form.Item>


            <Form.Item name='insuranceStatus' noStyle>
              <Select
                placeholder='是否接入医保'
                onChange={queryChange}
                allowClear
              >
                <Select.Option value={1}>是</Select.Option>
                <Select.Option value={0}>否</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name='potionStatus' noStyle>
              <Select
                placeholder='是否开通代煎'
                onChange={queryChange}
                allowClear
              >
                <Select.Option value={0}>是</Select.Option>
                <Select.Option value={1}>否</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name='time' noStyle>
              <DateSelect
                options={[
                  DateRangeType.Yesterday,
                  DateRangeType.ThisWeek,
                  DateRangeType.ThisMonth,
                  DateRangeType.ThisYear,
                  DateRangeType.Range,
                ]}
                style={{ width: '13rem' }}
                labelPrefix=''
                placeholder='日期-全部'
                namePrefix='endTime'
                onChange={queryChange}
              />
            </Form.Item>
          </Space>
          <Space>
            <Button type='primary' onClick={queryChange}>
              查询
            </Button>
            <Button onClick={() => {
              form.resetFields()
              queryChange()
            }}>
              重置
            </Button>
            <Button type='primary' onClick={() => {
              ListExport()

            }}>
              导出
            </Button>
          </Space>
        </Row>
      </Form>
    </div>
  );
}
